import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid ${props => props.theme.colors.borderLight};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  min-width: 160px;
  justify-content: center;

  &:hover {
    background: rgba(0, 0, 0, 0.5);
    border-color: ${props => props.theme.colors.border};
    box-shadow: 0 0 10px ${props => props.theme.colors.borderLight};
  }
`;

const ToggleLabel = styled.span`
  color: ${props => props.theme.colors.textSecondary};
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${props => props.theme.colors.primary};
    box-shadow: 0 0 5px ${props => props.theme.colors.primary};
  }
`;

const ThemeToggle: React.FC = () => {
  const { themeName, toggleTheme } = useTheme();
  
  let currentLabel = 'Night Ops';
  if (themeName === 'shadowGrid') currentLabel = 'Shadow Grid';
  if (themeName === 'modernWarfare') currentLabel = 'Nova Frontier';

  return (
    <ToggleContainer onClick={toggleTheme} title="Click to cycle themes">
      <ToggleLabel>{currentLabel}</ToggleLabel>
    </ToggleContainer>
  );
};

export default ThemeToggle;
